import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import Button from '../elements/Button';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

class Scriptores extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      invertMobile,
      invertDesktop,
      alignTop,
      imageFill,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'scriptores section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'scriptores-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const splitClasses = classNames(
      'split-wrap',
      invertMobile && 'invert-mobile',
      invertDesktop && 'invert-desktop',
      alignTop && 'align-top'
    );

    const sectionHeader = {
      title: 'Our Main Product: Scriptores',
      paragraph: 'A specialized software solution for oxygen device companies to manage patient services, equipment tracking, and billing operations.'
    };

    return (
      <section
        {...props}
        id="scriptores"
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content invert-color" />
            <div className={splitClasses}>
              <div className="split-item">
                <div className={
                  classNames(
                    'split-item-image center-content-mobile reveal-scale-up',
                    imageFill && 'split-item-image-fill'
                  )}
                  data-reveal-container=".split-item">
                  <div style={{ textAlign: 'center', padding: '10px' }}>
                    <div style={{ borderRadius: '16px', overflow: 'hidden', display: 'inline-block' }}>
                      <Image
                        src="/logoscriptores.png"
                        alt="Scriptores Logo"
                        width={200}
                        height={200} />
                    </div>
                  </div>
                </div>
                <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item" data-reveal-delay="200">
                  <h3 className="mt-0 mb-12">
                    Specialized Solution for Oxygen Device Companies
                  </h3>
                  <p className="m-0 mb-20">
                    Scriptores automates prescription executions, integrates directly with EOPPY (Greek health system), and streamlines all aspects of your oxygen device operations—from patient management to billing.
                  </p>
                  <div className="mb-20" style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                    <div className="reveal-from-bottom" data-reveal-delay="250" data-reveal-container=".split-item">
                      <div style={{ textAlign: 'left' }}>
                        <div className="h2 m-0" style={{ color: 'var(--color-primary)', fontWeight: 'bold' }}>10+</div>
                        <div className="text-xs" style={{ color: 'var(--color-high)' }}>Companies Using Scriptores</div>
                      </div>
                    </div>
                    <div className="reveal-from-bottom" data-reveal-delay="300" data-reveal-container=".split-item">
                      <div style={{ textAlign: 'left' }}>
                        <div className="h2 m-0" style={{ color: 'var(--color-primary)', fontWeight: 'bold' }}>1000+</div>
                        <div className="text-xs" style={{ color: 'var(--color-high)' }}>Prescriptions Executed Daily</div>
                      </div>
                    </div>
                  </div>
                  <div className="reveal-from-bottom" data-reveal-delay="350" data-reveal-container=".split-item">
                    <Button tag="a" color="primary" href="#/scriptores_sandbox" wideMobile>
                      Try Scriptores Sandbox
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="tiles-wrap" style={{ marginTop: '32px' }}>
              <div className="tiles-item reveal-from-bottom">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      Patient Management
                    </h4>
                    <p className="m-0 text-sm">
                      Efficiently manage patient records, medical requirements, and service history. Track all patient interactions and equipment assignments in one centralized system.
                    </p>
                  </div>
                </div>
              </div>
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="100">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      Equipment Tracking
                    </h4>
                    <p className="m-0 text-sm">
                      Monitor oxygen equipment inventory in real-time. Track which equipment is assigned to which patient, delivery status, and maintenance schedules.
                    </p>
                  </div>
                </div>
              </div>
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      Billing & Compliance
                    </h4>
                    <p className="m-0 text-sm">
                      Automate recurring billing for rental services. Ensure compliance with medical equipment regulations and maintain accurate financial records.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Scriptores.propTypes = propTypes;
Scriptores.defaultProps = defaultProps;

export default Scriptores;
